import React from 'react';
import aboutThumb from '../../../assets/images/backoffice-invoice-sample.jpg';

function ShowCase() {
    return (
        <>
            <section className="appie-about-area mb-50  pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-about-box wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-5">
                                        <div className="about-thumb">
                                            <img
                                                className="rounded"
                                                src={aboutThumb}
                                                alt="OTO POS Receipt"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="appie-about-content">
                                            <span>Backoffice : Finance operations</span>
                                            <h3 className="title">
                                                Manage invoices and proforma in one place
                                            </h3>
                                            <p>
                                                Simplify the process of creating, sending, and
                                                managing invoices and proforma
                                            </p>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Automated reminders</h4>
                                                    <p>
                                                        Get notified when payments are due and keep
                                                        track of payments received.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Payment Methods</h4>
                                                    <p>
                                                        Whether you prefer to accept cash, credit
                                                        cards, mobile payments, or any combination
                                                        thereof, our app has you covered
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Real-time updates</h4>
                                                    <p>
                                                        Track your invoice and proforma status in
                                                        real-time, so you always know where your
                                                        business stands.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Digital Stamp</h4>
                                                    <p>
                                                        You no longer need to print, stamp and scan
                                                        your invoices. Stamp and sign your invoices
                                                        within the app.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ShowCase;
